import { render, staticRenderFns } from "./CommonTagList.vue?vue&type=template&id=734474c7&scoped=true"
import script from "./CommonTagList.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTagList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734474c7",
  null
  
)

export default component.exports